const PHONE_HREF = 'tel:+905362771709';
const WA_HREF = 'https://wa.me/905362771709';

export default function CtaBanner() {
  return (
    <section className="relative py-24 overflow-hidden bg-[#FAF7F2]">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="/images/home/cta-bg.webp"
          srcSet="/images/home/cta-bg-480.webp 480w, /images/home/cta-bg.webp 1200w"
          sizes="100vw"
          alt="Alaçatı ve İzmir Tente Çözümleri"
          width={1200}
          height={896}
          className="w-full h-full object-cover object-top"
          loading="lazy"
          decoding="async"
        />
        <div className="absolute inset-0 bg-[#FAF7F2]/90"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="w-8 h-px bg-[#D4A853]"></span>
              <span className="text-[#D4A853] text-xs font-bold tracking-widest uppercase">Alaçatı &amp; İzmir&apos;e Özel</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-black text-[#111827] leading-tight mb-5">
              Tente Çözümleri<br />
              <span className="text-[#D4A853]">Hemen Bizimle</span><br />
              İletişime Geçin
            </h2>
            <p className="text-[#666] text-sm leading-relaxed max-w-md">
              Ücretsiz keşif için hemen arayın. Alaçatı, Çeşme, Ilıca ve çevre bölgelere hizmet veriyoruz. Uzman ekibimiz yerinde değerlendirme yapar, en uygun çözümü önerir.
            </p>
          </div>

          {/* Right: CTA cards */}
          <div className="flex flex-col gap-4">
            <a
              href={PHONE_HREF}
              className="flex items-center gap-5 bg-[#111827] hover:bg-[#1f2937] p-6 transition-colors cursor-pointer group"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-[#D4A853] flex-shrink-0">
                <i className="ri-phone-line text-[#111827] text-2xl"></i>
              </div>
              <div className="flex-1">
                <p className="text-[#D4A853] text-xs font-bold tracking-widest uppercase mb-1">Hemen Ara</p>
                <h3 className="text-white font-black text-lg">Ücretsiz Keşif İçin Ara</h3>
                <p className="text-white/40 text-xs mt-1">Yerinde ölçüm ve teklif</p>
              </div>
              <i className="ri-arrow-right-line text-white/30 text-xl group-hover:text-[#D4A853] transition-colors"></i>
            </a>

            <a
              href={WA_HREF}
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="flex items-center gap-5 bg-[#FAF7F2] border-2 border-[#111827] hover:bg-[#111827] p-6 transition-colors cursor-pointer group"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-[#111827] group-hover:bg-[#D4A853] flex-shrink-0 transition-colors">
                <i className="ri-whatsapp-line text-white group-hover:text-[#111827] text-2xl transition-colors"></i>
              </div>
              <div className="flex-1">
                <p className="text-[#D4A853] text-xs font-bold tracking-widest uppercase mb-1">WhatsApp</p>
                <h3 className="text-[#111827] group-hover:text-white font-black text-lg transition-colors">Hızlı Teklif İçin WhatsApp</h3>
                <p className="text-[#888] group-hover:text-white/50 text-xs mt-1 transition-colors">Anında yanıt alın</p>
              </div>
              <i className="ri-arrow-right-line text-[#111827]/30 group-hover:text-[#D4A853] text-xl transition-colors"></i>
            </a>

            {/* Trust badges */}
            <div className="flex gap-4 pt-2">
              {['Ücretsiz Keşif', 'Garantili Montaj', 'Hızlı Kurulum'].map((t) => (
                <div key={t} className="flex items-center gap-1.5 text-[#888] text-xs">
                  <i className="ri-checkbox-circle-fill text-[#D4A853]"></i>
                  {t}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
